import { CALENDAR_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_BOARDS = `${CALENDAR_SERVICE}/boards`;

export const boards = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_BOARDS,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });

    const response = await apiRequest(options);

    return response;
  },
  getById: async ({ id, signal } = {}) => {
    const options = await apiOptions({
      url: `${API_BOARDS}/${id}`,
      method: "get",
      signal,
    });

    const response = await apiRequest(options);

    return response;
  },
  create: async ({ data, signal, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: API_BOARDS,
      method: "post",
      signal,
      data,
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
  update: async ({ id, data, signal, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_BOARDS}/${id}`,
      method: "patch",
      signal,
      data,
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
  delete: async ({ id, modifiedOn, signal, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_BOARDS}/${id}`,
      method: "delete",
      signal,
      data: { modifiedOn },
    });

    const response = await apiRequest(options, toastMessageConfig);
    return response;
  },
};
